import {
  PUBLIC_SHOPIFY_STORE_NAME_EU,
  PUBLIC_SHOPIFY_STORE_NAME_UK,
  PUBLIC_SHOPIFY_STORE_NAME_US
} from '$env/static/public';

export const PREVIEW_COOKIE_KEY = '__hey-harper-preview__';
export const ISR_BYPASS_COOKIE_KEY = '__prerender_bypass';
export const ISR_ALLOW_QUERY = ['q'];
export const AB_TEST_KEY = 'ab-test-key';
export const AB_TEST_ID_KEY = 'ab-test-id-key';

const SHOPIFY_CART_US_KEY = '__hey-harper-us-cart__';
const SHOPIFY_CART_UK_KEY = '__hey-harper-uk-cart__';
const SHOPIFY_CART_EU_KEY = '__hey-harper-eu-cart__';

export const SHOPIFY_CART_KEY = {
  us: SHOPIFY_CART_US_KEY,
  uk: SHOPIFY_CART_UK_KEY,
  eu: SHOPIFY_CART_EU_KEY
} as const;

export const SHOPIFY_STORE_NAME = {
  us: PUBLIC_SHOPIFY_STORE_NAME_US,
  uk: PUBLIC_SHOPIFY_STORE_NAME_UK,
  eu: PUBLIC_SHOPIFY_STORE_NAME_EU
} as const;

export enum ProductMetafields {
  SAVE_ON_SETS = 'save_on_sets',
  VARIANT_IMAGES = 'multiple_variant_images_by_alt_text',
  VARIANT_COLOR = 'variantcolor',
  CARD_PATTERN = 'product_card_pattern_url',
  CARD_OBJECT_FIT = 'product_card_object_fit_cover',
  A_TEST_VERSION_MEDIA_INDEX = 'a_test_version_media_index',
  PRE_ORDER_DAY = 'pre_order_day'
}

export enum ProductTags {
  BEST_SELLER = '__label:Bestseller',
  NEW = '__label:New',
  LAST_UNITS = '__label:Last Units',
  LIMITED = '__label:Limited Edition'
}

export const VIDEO_EXTENSIONS = ['mp4', 'webm', 'ogg'];
export const ITEMS_AVAILABLE_THRESHOLD = 10;

export const CART_DRAWER_ID = 'cart';

export const FREE_GIFT = '_free_gift';
export const PRE_ORDER_ATTRIBUTE = 'Pre-Sale - Ships On';

export const FILTERS_VENDOR_PREFIX = 'filter.p.vendor';

export const SHOP_SUBCATEGORY_FILTER_ID = 'filter.p.m.custom.sub_categories';

export const SEARCH_PARAM_KEY = 'q';

export const AUTH_DRAWER_IDS = {
  LOGIN: 'login',
  SIGNUP: 'signup',
  FORGOT_PASSWORD: 'forgot-password',
  FORGOT_PASSWORD_STEP_TWO: 'forgot-password-step-two',
  RESET_PASSWORD: 'reset-password'
} as const;

export const RESET_PASSWORD_PARAM = 'reset_url';

export const ACTION_PARAM = 'action';

export const getStorefrontGraphqlEndpoint = (storeName: string) => {
  return `https://${storeName}.myshopify.com/api/2023-07/graphql.json`;
};

export const getAdminGraphqlEndpoint = (storeName: string) => {
  return `https://${storeName}.myshopify.com/admin/api/2023-10/graphql.json`;
};

export const WISHLIST_EMPTY_VALUE = 'empty';

export const CAMPAIGN_COLORS = {
  'tone-1': 'background-color',
  'tone-2': 'text-color',
  'tone-3': 'alt-text-color',
  'tone-4': 'alt-background'
};

export const DEFAULT_CAMPAIGN_COLOR = 'campaign-color-1';
export const BLACK_CAMPAIGN_COLOR = 'campaign-color-0'; // NOTE: this is the color for black friday theme and not to be changed on storyblok and here.
export const PRODUCT_CATEGORIES: Record<string, string[]> = {
  necklaces: ['Necklace', 'Necklaces', 'Charm', 'Choker', 'Collier'],
  earrings: ['Earrings', 'Earring', 'Huggies', 'Piercing', 'Cuff', 'Stud', 'Boucles', 'Créoles'],
  rings: ['Rings', 'Ring', 'Bague']
};

export const GUEST = 'guest';
export const LOGGED_IN = 'logged_in';
export const DEFAULT_VENDOR = 'Hey Harper';

export const DEFAULT_TITLE = 'Default Title';
